import React from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import { PngImages } from "../../Utils/LocalImages";

const OurServices = () => {
  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"Services"}   breadCrumpPageTitle={"Services"}   />
      <div className="text-content-page-container d-flex flex-column align-items-center">
        <div className="services-cards-conatiner d-flex flex-column container p-0">
          <ServiceCard
            title={"Empowering Students with E-Learning Services"}
            description={"At Learn and Achieve, our mission is to empower students, parents, and educators with E-services that foster learning and growth. We understand the importance of quality education, and to that end, we offer a range of services to support K12 students. Our YouTube channel, filled with educational content, is just a click away. In addition, we provide direct links to YouTube videos and insightful blogs that cater to the diverse needs of students, ensuring that they have the resources they need to excel in their studies."}
            image={PngImages.serviceOne}
            backgroundColor={"#F6FFD2"}
          />

          <ServiceCard
            title={"Charting Your Path: Free Career Guidance"}
            description={"The journey to a successful career can be daunting, especially for students navigating the transition  from school to work. Learn and Achieve offers free career guidance services to help students make informed choices about their future. Our experts provide invaluable insights and advice, empowering students to make confident decisions about their career paths, ultimately leading them toward a brighter, more fulfilling future."}
            image={PngImages.serviceTwo}
            backgroundColor={"#DAFFFF"}
            swapLayout={true}
          />

          <ServiceCard
            title={"Supporting Every Learner: Special Education and Remedial Services"}
            description={"We believe in an inclusive education system, and that's why Learn and Achieve offers free special education and remedial services. For children who require additional support, our psychiatric services are designed to address their unique needs. Our team of professionals is dedicated to helping every child reach their full potential, ensuring that no student is left behind."}
            image={PngImages.serviceThree}
            backgroundColor={"#FFE8E8"}
            swapLayout={false}
          />

          <ServiceCard
            title={"Aim High: Guiding You to Success in Competitive Examinations"}
            description={"Success in competitive examinations can open doors to various opportunities. Learn and Achieve is here to guide you on this journey. We provide expert guidance and resources to help you prepare for these challenging exams, making sure you have the knowledge and confidence you need to excel."}
            image={PngImages.serviceFour}
            backgroundColor={"#FFF5DA"}
            swapLayout={true}
          />

          <ServiceCard
            title={"Join Us in the Pursuit of Knowledge"}
            description={"At Learn and Achieve, we are committed to promoting the pursuit of knowledge and supporting students, parents, and educators. Our free services, ranging from e-learning resources and career guidance to special education and competitive examination support, are designed to empower individuals on their educational journeys. Join us in the pursuit of excellence and unleash your potential with Learn and Achieve."}
            image={PngImages.serviceFive}
            backgroundColor={"#CFFFD1"}
            swapLayout={false}
          />
        </div>
      </div >
    </div>
  );
};
export default OurServices;

function ServiceCard({ image, backgroundColor, swapLayout = false, title, description }) {
  return <div className="service-parent-card service-parent-card-gap">
    {swapLayout ? <Image className="service-parent-card-image" src={image} /> : null}
    <div className="service-text-content-card" style={{ backgroundColor: backgroundColor }}>
      <Image className="service-parent-card-inner-image w-100" src={image} />
      <h2 className="large-text fw-600 darkBlueColor mb-0">
        {title}
      </h2>
      <p className="medium-text fw-400 black mb-0 mt-3">
        {description}
      </p>
    </div>
    {!swapLayout ? <Image className="service-parent-card-image" src={image} /> : null}
  </div>;
}
